if (!customElements.get("m-blog-posts")) {
  class MBlogPosts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.enableSlider = this.dataset.enableSlider !== "false";
      this.items = parseInt(this.dataset.items) || 4;
      this.showPagination = this.dataset.showPagination !== "false";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) || 5;

      this.sliderContainer = this.querySelector(".swiper-container") || this.querySelector(".m-blog-grid__slider-container");

      if (this.enableSlider && this.sliderContainer) {
        this.checkAndInit();
      }
    }

    checkAndInit() {
      if (typeof MinimogLibs !== "undefined" && MinimogLibs.Swiper) {
        this.initSlider();
      } else {
        const interval = setInterval(() => {
          if (typeof MinimogLibs !== "undefined" && MinimogLibs.Swiper) {
            clearInterval(interval);
            this.initSlider();
          }
        }, 50);
        setTimeout(() => clearInterval(interval), 5000);
      }
    }

    initSlider() {
      if (this.slider || typeof MinimogLibs === "undefined" || !MinimogLibs.Swiper) return;

      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideWrapper = this.querySelector(".swiper-wrapper");
      const slideCount = slideWrapper ? slideWrapper.childElementCount : 0;
      const self = this;

      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        grabCursor: true,
        allowTouchMove: true,
        simulateTouch: true,
        touchEventsTarget: "container",
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: false,
            }
          : false,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "swiper-pagination-bullet m-dot",
              bulletActiveClass: "swiper-pagination-bullet-active m-dot--active",
            }
          : false,
        navigation:
          this.showNavigation && (nextButton || prevButton)
            ? {
                nextEl: nextButton,
                prevEl: prevButton,
              }
            : false,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 3.5,
            spaceBetween: 16,
          }
        },
        on: {
          init: function (swiper) {
            self.updateControlsVisibility(swiper, controlsContainer, slideCount);
          },
          resize: function (swiper) {
            self.updateControlsVisibility(swiper, controlsContainer, slideCount);
          },
          breakpoint: function (swiper, breakpointParams) {
            self.updateControlsVisibility(swiper, controlsContainer, slideCount);
          },
        },
      });

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }
    }

    updateControlsVisibility(swiper, controlsContainer, slideCount) {
      if (!controlsContainer) return;
      const isDesktop = window.innerWidth >= 1024;
      const currentPerView = swiper.params.slidesPerView || 1;

      // On desktop, only enable slider & pills if items > 4
      if (isDesktop && slideCount <= 4) {
        controlsContainer.style.setProperty("display", "none", "important");
        swiper.allowTouchMove = false;
      } else if (slideCount <= currentPerView) {
        controlsContainer.style.setProperty("display", "none", "important");
        swiper.allowTouchMove = false;
      } else {
        controlsContainer.style.setProperty("display", "flex", "important");
        swiper.allowTouchMove = true;
      }
    }
  }

  customElements.define("m-blog-posts", MBlogPosts);
}
